<template>
  <!-- <div id="Complete" :style="{ backgroundColor: getColor.primaryColor }" ref="complete"> -->
  <div id="Complete" ref="complete">
    <div class="complete-container">
      <div class="head-title" :style="{ color: getColor.primaryColor }">{{ $t('RESULT.PAYMENT_COMPLETE') }}</div>
      <div class="horizon-short" :style="{ borderColor: getColor.primaryColor }"></div>
      <div class="franchisee-name">{{ GET_PAYMENT_INFORMATION.payload.store_name || 'TEST CAFE' }}</div>
      <div class="price">{{ GET_PAYMENT_RESULT.amount }} {{ $t('PAYMENT_HEADER.UNIT') }}</div>
      <div class="horizon-dot"></div>
      <div class="contents">
        <div class="content-row">
          <div class="content-title">{{ $t('RESULT.PRODUCT_NAME') }}</div>
          <div class="content-context">{{ GET_PAYMENT_INFORMATION.title }}</div>
        </div>
        <div class="content-row">
          <div class="content-title">{{ $t('RESULT.APPROVAL_DATE') }}</div>
          <div class="content-context">{{ GET_PAYMENT_RESULT.approval_at | datime }}</div>
        </div>
        <div class="content-row">
          <div class="content-title">{{ $t('RESULT.PAYMENT_METHODS') }}</div>
          <div class="content-context">{{ GET_PAYMENT_RESULT.pay_kind | payMethod }}</div>
        </div>
        <div class="content-row" v-if="GET_PAYMENT_INFORMATION.pay_method === 'local'">
          <div class="content-title">{{ $t('RESULT.INSTALLMENT_MONTHS') }}</div>
          <div class="content-context">{{ GET_PAYMENT_RESULT.quota | installment }}</div>
        </div>
        <div class="content-row">
          <div class="content-title">{{ $t('RESULT.APPROVAL_NUMBER') }}</div>
          <div class="content-context">{{ GET_PAYMENT_RESULT.approval_no }}</div>
        </div>
      </div>
    </div>

    <div class="button-container">
      <button class="submit" :style="{ color: getColor.primaryColor, borderColor: getColor.primaryColor }" @click="completePayment">{{ $t('COMMON.CONFIRM') }}</button>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION',
      'GET_PAYMENT_RESULT': 'GET_PAYMENT_RESULT',
      'GET_REDIRECT': 'GET_REDIRECT'
    }),
    styleObject: () => {

    }
  },
  filters: {
    installment(value) {
      if(value === "00" || value === "0") {
        return '일시불'
      } else {

        return `${Number(value)}개월`;
      }
    },
    payMethod(value) {
      if(value === 'card') {
        return '카드';
      }
    },
    datime(value) {
      let localTime = moment.utc(value).toDate();
      localTime = moment(localTime).format('YYYY-MM-DD HH:mm:ss')

      return localTime;
    }
  },
  created () {
    console.log(this.GET_PAYMENT_INFORMATION)
    console.log(this.GET_PAYMENT_RESULT)
  },
  mounted () {
    this.setBodyColor(`linear-gradient(to top, ${this.getColor.primaryColor}, ${this.getColor.secondaryColor}) fixed`)
  },
  destroyed () {
    this.setBodyColor('#f2f2f2');
  },
  methods: {
    setBodyColor(color) {
      document.querySelector('body').style.background = color;
    },
    completePayment () {
      console.log(this.GET_PAYMENT_INFORMATION.payload)
      let url = this.GET_PAYMENT_INFORMATION.payload.success_url;
      // let url = this.GET_REDIRECT.success;

      console.log(url)
      location.replace(url)
      // location.href = url
    } 
  }
}
</script>

<style lang="scss">
#Complete {
  @include basic-display;

  padding: 9px 10px 115px;

  .complete-container {
    padding: 40px 20px 30px;

    border-radius: 18px;

    background-color: white;

    text-align: center;
    
    .head-title {
      height: 40px;

      font-size: 24px;
      font-weight: bold;

      line-height: 1.42;
    }

    .horizon-short {
      width: 100px;
      margin: 20px auto 0px;

      border: solid 1px black;      
    }

    .franchisee-name {
      height: 28px;
      margin-top: 38px;

      font-size: 17px;
      color: #424242;
      
      line-height: 1.65;
    }

    .price {
      height: 50px;
      margin-top: 13px;

      font-size: 40px;
      font-weight: bold;

      line-height: 1.25;
    }

    .horizon-dot {
      height: 1px;
      margin-top: 45px;

      background-image: url('../../images/horizon-dot.svg');
    }

    .contents {
      padding: 29px 20px 0px;

      .content-row {
        overflow: hidden;

        height: 24px;

        font-size: 15px;
        
        line-height: 1.6;

        &:not(:first-of-type) {
          margin-top: 10px;
        }

        .content-title {
          float: left;

          font-weight: bold;
          color: #999;
        }
        .content-context {
          float: right;

          color: #1a1a1a;
        }
      }
    }
  }

  .button-container {
    position: fixed;

    right: 0;
    bottom: 10px;
    left: 0;

    text-align: center;

    .submit {
      width: 240px;
      height: 50px;
      border: solid 1px white;
      border-radius: 25px;
      font-size: 17px;
      background-color: white;
    }
  }
}
</style>